import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Resets scroll position on navigation across the entire site.
// Rules:
// 1. Forward/link navigation (PUSH, REPLACE) scrolls instantly to the top.
// 2. Anchor links (URLs with a #hash) scroll to the referenced section instead.
// 3. Browser back/forward (POP) is left untouched so the browser can restore
//    the previous scroll position, which is what users expect.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Back or forward navigation: defer to the browser's scroll restoration.
    if (navigationType === "POP") return;

    if (hash) {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        // Small timeout so the target section is rendered before we scroll.
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 0);
        return;
      }
    }

    // Standard route change: jump instantly to the top.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash, navigationType]);

  return null;
}
